import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const errorMessage = 'При добавлении жильца произошла ошибка';

const saveClient = (client) =>
  request.post('HousingStock/client', client, errorMessage, 'Error');

const bindClient = (bindData) =>
  request.put('HousingStock/bind_client', bindData, errorMessage, 'Error');

const mutationFn = async ({ addressId, client }) => {
  const savedClient = await saveClient(client);

  if (savedClient === 'Error' || !savedClient?.id) return 'Error';

  const bindResult = await bindClient({
    addressId,
    clientId: savedClient.id,
    isOwner: client.isOwner,
    availableForClient: true,
  });

  return bindResult === 'Error' ? 'Error' : savedClient;
};

export const useAddTenantMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
